import { createSlice } from "@reduxjs/toolkit";
import {
  getSalarySettings,
  patchSalarySettings,
} from "./salarySettingsActions";

const initialState = {
  loading: false,
  error: null,
  success: false,
  salarySettings: null,
};

const salarySettingsSlice = createSlice({
  name: "salary_settings",
  initialState,
  reducers: {
    resetSalarySettingError: (state, action) => {
      if (action?.payload) {
        delete state.error[action?.payload];
        if (Object.keys(state.error)?.length === 0) {
          state.error = null;
        }
      } else {
        state.error = null;
      }
      state.loading = false;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSalarySettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSalarySettings.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.salarySettings = payload ? payload : null;
      })
      .addCase(getSalarySettings.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(patchSalarySettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(patchSalarySettings.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.salarySettings = payload;
      })
      .addCase(patchSalarySettings.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});
export const { resetSalarySettingError } = salarySettingsSlice.actions;
export default salarySettingsSlice.reducer;
